import { ThymeEventError } from '@thyme/libs/src/errors/errors'
import { getLogger } from '@thyme/libs/src/logging/logger'

export type EventServiceClientConfig = {
  url: string
  apiKey: string
  isLocal: boolean
}

export type SendEventOptions = {
  sessionId?: string
}

export type EventServiceClient = {
  sendEvent(
    eventName: string,
    data: Record<string, unknown>,
    options?: SendEventOptions
  ): Promise<void>
}

/**
 *
 * @param config
 */
export function createEventServiceClient(
  config: EventServiceClientConfig
): EventServiceClient {
  return {
    async sendEvent(eventName, data, options) {
      if (config.isLocal) {
        getLogger().debug(
          'Local env detected, not sending event to Event Service',
          { event_name: eventName, data }
        )
        return
      }

      getLogger().info('Sending monitoring event to Event Service', {
        event_name: eventName,
        data,
      })

      try {
        await fetch(config.url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${config.apiKey}`,
          },
          body: JSON.stringify({
            event: eventName,
            data,
            ...(options?.sessionId && { sessionId: options.sessionId }),
          }),
        })
      } catch (err) {
        const error = ThymeEventError.fromError(err)
        getLogger().error(
          'Error sending monitoring event to Event Service',
          error
        )
      }
    },
  }
}
